import {
  Block,
  Launch,
} from '@mui/icons-material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LocationOn from '@mui/icons-material/LocationOn';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NoteAlt from '@mui/icons-material/NoteAlt';
import Restaurant from '@mui/icons-material/Restaurant';
import SearchIcon from '@mui/icons-material/Search';
import TaskAlt from '@mui/icons-material/TaskAlt';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Popover,
  Skeleton,
  Switch,
  Typography,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from '../../navigation/AppContainer/appBar';
import { searchQuestri } from '../../redux/search/actions';
import { SEARCH_TYPE } from '../../utils/enumHelper';
import HorseIcon from '../CustomIcons/Horse';
import Horse from '../Horse';
import NoteItem from '../NoteItem';
import User from '../User';
import styles from './styles';

const HORSE_PREFIX = '/horses/';
const USER_PREFIX = '/users/';
const NOTE_PREFIX = '/notes/';

const getIconForExtract = (result) => {
  if (result.type === SEARCH_TYPE.Note) {
    return <NoteAlt color="secondary" />;
  } if (result.type === SEARCH_TYPE.User) {
    return <AccountCircle color="secondary" />;
  } if (result.type === SEARCH_TYPE.Feed) {
    return <Restaurant color="secondary" />;
  } if (result.type === SEARCH_TYPE.Horse) {
    return <HorseIcon color="#9e9e9e" />;
  } if (result.type === SEARCH_TYPE.Location) {
    return <LocationOn color="secondary" />;
  }
  return <NoteAlt color="secondary" />;
};

export class SearchListComponent extends React.Component {
  renderQuestriSearchResults() {
    const {
      search,
      navigate,
      searchText,
      searchResults,
      additionalQueryParams,
      hideSearchResults,
      classes,
      isFetching,
      barnHorsesMap,
      barnUsersMap,
    } = this.props;

    return (
      <List className={classes.list} dense>
        {
          isFetching && [1, 2, 3, 4, 5].map((item) => (
            <ListItem
              key={`search-result-loading-${item}`}
            >
              <ListItemButton>
                <ListItemAvatar>
                  <Skeleton variant="circular" width={40} height={40} />
                </ListItemAvatar>
                <ListItemText
                  primaryTypographyProps={{ component: 'div' }}
                  secondaryTypographyProps={{ component: 'div' }}
                  primary={<Skeleton height={20} width="65%" />}
                  secondary={(
                    <>
                      <Skeleton height={15} width="95%" style={{ marginBottom: 6 }} />
                      <Skeleton height={15} width="50%" />
                    </>
                  )}
                />
              </ListItemButton>
            </ListItem>
          ))
        }
        {
          searchResults.content.map((result) => {
            // For now only going to search on user and horse
            let horse = null;
            let user = null;
            let note = null;
            let title = '';
            if (result.url && result.url.indexOf(HORSE_PREFIX) >= 0 && result.type === 'Horse') {
              horse = barnHorsesMap[result.url.substr(HORSE_PREFIX.length)] && barnHorsesMap[result.url.substr(HORSE_PREFIX.length)][0];
              title = horse && horse.horse.name;
            } else if (result.url && result.url.indexOf(USER_PREFIX) >= 0 && result.type === 'User') {
              user = barnUsersMap[result.url.substr(USER_PREFIX.length)] && barnUsersMap[result.url.substr(USER_PREFIX.length)][0];
              title = user && user.userFullName;
            } else if (result.url && result.url.indexOf(NOTE_PREFIX) >= 0 && result.type === 'Note') {
              note = {
                id: result.url.substr(result.url.indexOf(NOTE_PREFIX) + NOTE_PREFIX.length),
                title: result.title,
                type: (result.metadata && result.metadata.noteType) || 'Note',
                note: result.description,
                information: result.metadata,
                createdBy: result.auth0UserId,
                createdTimestamp: result.timestamp,
                horse: { id: result.url.substr(result.url.indexOf(HORSE_PREFIX) + 8, result.url.indexOf(NOTE_PREFIX) - 8) },
                taskId: result.metadata && result.metadata.taskId,
              };
            }

            return (
              <ListItemButton
                divider
                key={`search-result-${result.id}`}
                onClick={() => {
                  if ((!horse && !user && !note)) { return; }
                  if (note) {
                    navigate(`/horses/${note.horse.id}?noteId=${note.id}&tab=notes`);
                  } else {
                    navigate(result.url);
                  }
                  hideSearchResults();
                }}
              >
                {
                  horse && (
                    <ListItemAvatar>
                      <Horse hideName horse={horse.horse} />
                    </ListItemAvatar>
                  )
                }
                {
                  user && (
                    <ListItemAvatar>
                      <User mini user={user} size={40} />
                    </ListItemAvatar>
                  )
                }
                {!horse && !user && !note && (
                  <ListItemAvatar><Avatar sx={{ background: 'transparent !important' }}><Block color="secondary" /></Avatar></ListItemAvatar>
                )}
                {
                  (horse || user) && (
                    <ListItemText primary={title || result.title} primaryTypographyProps={{ variant: 'h5' }} secondary={result.description} />
                  )
                }
                {note && (
                  <NoteItem
                    note={note}
                    horseId={note.horse.id}
                    isAdmin={false}
                    hideActions
                    hideNote={false}
                    includeHorseInfo
                    divider={false}
                  />
                )}

                {(!horse && !user && !note)
                  ? <ListItemText primary="Result no longer available" />
                  : (

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {getIconForExtract(result)}
                      <Launch color="primary" sx={{ ml: 0.5 }} />
                    </Box>
                  )}
              </ListItemButton>
            );
          })
        }
        {!isFetching && searchResults.content.length === 0 && <Typography variant="caption" align="center">No Results Found.</Typography>}
        {!searchResults.last
          && (
            <ListItem>
              <div className={classes.center}>
                <Button
                  variant="outlined"
                  color="primary"
                  disabled={isFetching}
                  loading={isFetching}
                  loadingPosition="start"
                  startIcon={<NavigateNextIcon />}
                  onClick={() => search(
                    searchText,
                    additionalQueryParams,
                    (searchResults.number + 1),
                    searchResults.size,
                  )}
                >
                  Load Next Results
                </Button>
              </div>
            </ListItem>
          )}
      </List>
    );
  }

  render() {
    const {
      handleSearchChange,
      searchText,
      debouncedSearchText,
      anchorElement,
      onlySearchFiles,
      searchHorses,
      searchUsers,
      searchNotes,
      onOnlySearchFilesChange,
      onSearchHorsesChange,
      onSearchUsersChange,
      onSearchNotesChange,
      navigate,
      hideSearchResults,
      classes,
      fullScreen,
    } = this.props;
    let notificationContainerClass = classes.notificationContainer;
    if (fullScreen) {
      notificationContainerClass = classes.notificationContainerFullScreen;
    }

    return (
      <Popover
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={!!(anchorElement && debouncedSearchText.length > 0)}
        aria-labelledby="search-results-list"
        anchorEl={anchorElement}
        onClose={hideSearchResults}
        classes={{
          paper:
            fullScreen
              ? classes.popoverPaperFullScreen
              : null,
        }}
      >
        <div
          className={notificationContainerClass}
        >
          <div className={classes.notificationListHeader}>

            <SearchIcon sx={{ mr: 1 }} />
            <Typography variant="h5" sx={{ flex: 1 }}>
              Search Results
            </Typography>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                value={searchText}
                onChange={handleSearchChange}
                placeholder="Search…"
                color="inherit"
                inputProps={{ 'aria-label': 'search' }}
              />
            </Search>
            <div>
              <IconButton onClick={hideSearchResults}>
                <Icon className={classes.close}>close</Icon>
              </IconButton>
            </div>
          </div>
          <Divider />
          <Box className={classes.searchFilters}>
            <Typography
              variant="caption"
              color="text.secondary"
              className={classes.searchFiltersLabel}
            >
              Search Filters
            </Typography>
            <FormGroup row className={classes.searchFilterOptions}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={searchHorses && !onlySearchFiles}
                    disabled={onlySearchFiles}
                    onChange={(event) => onSearchHorsesChange(event.target.checked)}
                    size="small"
                  />
                )}
                label="Horses"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={searchUsers}
                    disabled={onlySearchFiles}
                    onChange={(event) => onSearchUsersChange(event.target.checked)}
                    size="small"
                  />
                )}
                label="Users"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={searchNotes || onlySearchFiles}
                    disabled={onlySearchFiles}
                    onChange={(event) => onSearchNotesChange(event.target.checked)}
                    size="small"
                  />
                )}
                label="Notes"
              />
              <Button
                className={classes.searchTaskButton}
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<TaskAlt />}
                onClick={() => {
                  hideSearchResults();
                  navigate('/tasks');
                }}
              >
                Search Tasks
              </Button>
              <FormControlLabel
                control={(
                  <Switch
                    checked={onlySearchFiles}
                    onChange={(event) => onOnlySearchFilesChange(event.target.checked)}
                    size="small"
                  />
                )}
                label="Only Files"
              />
            </FormGroup>
          </Box>
          <Divider />
          <Box className={classes.resultsContainerStacked}>
            {this.renderQuestriSearchResults()}
          </Box>
        </div>
      </Popover>
    );
  }
}

SearchListComponent.propTypes = {
  searchText: PropTypes.string,
  debouncedSearchText: PropTypes.string,
  handleSearchChange: PropTypes.func,
  searchResults: PropTypes.object,
  anchorElement: PropTypes.object,
  additionalQueryParams: PropTypes.string,
  onlySearchFiles: PropTypes.bool,
  searchHorses: PropTypes.bool,
  searchUsers: PropTypes.bool,
  searchNotes: PropTypes.bool,
  onOnlySearchFilesChange: PropTypes.func,
  onSearchHorsesChange: PropTypes.func,
  onSearchUsersChange: PropTypes.func,
  onSearchNotesChange: PropTypes.func,
  search: PropTypes.func,
  navigate: PropTypes.func,
  hideSearchResults: PropTypes.func,
  classes: PropTypes.object,
  isFetching: PropTypes.bool,
  fullScreen: PropTypes.bool,
  barnHorsesMap: PropTypes.object,
  barnUsersMap: PropTypes.object,
};

SearchListComponent.defaultProps = {
  searchText: '',
  debouncedSearchText: '',
  handleSearchChange: () => { },
  searchResults: {
    content: [],
    page: 0,
    size: 0,
    last: true,
  },
  anchorElement: null,
  additionalQueryParams: '',
  onlySearchFiles: false,
  searchHorses: true,
  searchUsers: true,
  searchNotes: true,
  onOnlySearchFilesChange: () => { },
  onSearchHorsesChange: () => { },
  onSearchUsersChange: () => { },
  onSearchNotesChange: () => { },
  search: () => { },
  navigate: () => { },
  hideSearchResults: () => { },
  classes: {},
  isFetching: false,
  fullScreen: false,
  barnHorsesMap: {},
  barnUsersMap: {},
};

export const mapStateToProps = (state) => ({
  searchResults: state.search.search,
  isFetching: state.search.isSearching,
  barnHorsesMap: state.barn.barnHorsesMap,
  barnUsersMap: state.barn.barnUsersMap,
});

export const mapDispatchToProps = (dispatch) => ({
  search: (searchText, additionalQueryParams, page, size) => dispatch(searchQuestri(
    searchText,
    additionalQueryParams,
    page,
    size,
  )),
});

export default (withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchListComponent)));
